
import Button from 'primevue/button'
import ProgressSpinner from 'primevue/progressspinner'
import { defineComponent } from 'vue'

import { fetchUserInsights, UserInsights } from '../graphql'
import {
  formatInsightNumber,
  formatPeriodLabel,
  formatWeek,
  newerWeekOffset,
  olderWeekOffset,
} from '../insights'
import { createInsightsLoader } from './insights-loader'

export default defineComponent({
  name: 'UserInsights',
  components: { Button, ProgressSpinner },
  mixins: [createInsightsLoader<UserInsights>(fetchUserInsights)],
  computed: {
    maxWeeklySignups(): number {
      return Math.max(0, ...(this.insights?.weeklySignups.map(week => week.signups) ?? []))
    },
    maxWeeklySavedWorkouts(): number {
      return Math.max(0, ...(this.insights?.weeklySignups.map(week => week.savedWorkouts) ?? []))
    },
    newUserShare(): string {
      if (!this.insights || this.insights.totalUsers === 0) return '0'
      return ((this.insights.newUsersLast30Days / this.insights.totalUsers) * 100).toFixed(1).replace('.0', '')
    },
    weeklyTrendDescription(): string {
      if (!this.insights) return 'Weekly signup trend'
      return this.insights.weeklySignups
        .map(week => `${formatWeek(week.weekStart)}: ${week.signups} signups`)
        .join(', ')
    },
    weeklyActivityDescription(): string {
      if (!this.insights) return 'Weekly saved workout activity'
      return this.insights.weeklySignups
        .map(week => `${formatWeek(week.weekStart)}: ${week.savedWorkouts} saved workouts from ${week.activeAccounts} active accounts`)
        .join(', ')
    },
    selectedPeriodLabel(): string {
      return formatPeriodLabel(this.insights?.weeklySignups.map(week => week.weekStart) ?? [])
    },
  },
  methods: {
    formatNumber: formatInsightNumber,
    formatWeekLabel: formatWeek,
    formatPercentage(value: number): string {
      return `${value.toFixed(1).replace('.0', '')}%`
    },
    barHeight(value: number, maximum: number): number {
      if (maximum === 0) return 3
      return Math.max(3, (value / maximum) * 100)
    },
    showOlderWeeks() {
      if (!this.insights?.hasOlderWeeks) return
      this.loadInsights(olderWeekOffset(this.insights.weekOffset))
    },
    showNewerWeeks() {
      if (!this.insights?.hasNewerWeeks) return
      this.loadInsights(newerWeekOffset(this.insights.weekOffset))
    },
  },
})
